import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedService } from '../../../shared/services/shared.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  currentDate : Date = new Date();
  userName: string = '';

  constructor(
    private sharedService: SharedService,
    private router: Router
  ) {
    const user = this.sharedService.getCurrentUser();
    this.userName = user?.wuUserName || user?.userName || 'User';
  }
  @Output() toggleSidebar = new EventEmitter<boolean>(false);
  expandedBtn() {
    this.toggleSidebar.emit(true);
  }
  theme: boolean = false;
  themeChange(event: any) {
    this.theme = event.target.checked;
    if (this.theme == true) {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.setAttribute('data-theme', 'light');
    }
  }
  primaryColor: string = '#3c00c7'; // Default primary color
  secondaryColor: string = '#01888d'; // Default secondary color
  updateColors(variableName: string, colorValue: string): void {
    document.documentElement.style.setProperty(variableName, colorValue);
  }
  isDropdownOpen: boolean = false; // Track dropdown visibility

  @ViewChild('dropdownMenu') dropdownMenu!: ElementRef; // Reference to dropdown menu

  onDropdownClick(event: MouseEvent) {
    event.stopPropagation();
  }
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;

    if (
      this.isDropdownOpen &&
      this.dropdownMenu &&
      !this.dropdownMenu.nativeElement.contains(targetElement)
    ) {
      this.closeDropdown();
    }
  }
  closeDropdown() {
    this.isDropdownOpen = false;
  }
  logout() {
    this.sharedService.destroyCurrentUser();
    this.router.navigate(['/login']);
  }
}
